import { usePermissions } from '../lib/auth/usePermissions';

import type { ReactNode } from 'react';

// UX-only: hides children unless the user holds `permission`. NEVER the sole
// access control — the server enforces with @RequirePermission.
export function Can({ permission, children }: { permission: string; children: ReactNode }) {
  const { can } = usePermissions();
  return can(permission) ? <>{children}</> : null;
}
